import { QueryClient } from '@tanstack/react-query'
import { USER_KEYS } from 'hooks/user'

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [USER_KEYS.USER_CONFIGURATIONS],
        })
      },
    },
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
})
